import React from "react";
import BottomSheet from "./BottomSheet";
import BrowseBody from "./BrowseBody";
import { PROFILE_ICONS } from "./profileMenuIcons";
import { t } from "../i18n";
import "../pages/FanHomePage.css";
import "./DiscoverSheet.css";

// Discover (1.5.3, founder 10/26) — the talent's way into the fans' Browse
// screen: the same search, Industry Leaders carousel and "Saved" row
// (components/BrowseBody), in a tall sheet from the Profile menu like its
// neighbour Leaderboard. ProfilePage decides what a tap opens (onOpen): another
// talent's fan page, with a back arrow that brings this sheet back; their own
// card, their Preview.

type Props = {
  open: boolean;
  onClose: () => void;
  onOpen: (slug: string) => void;
};

export default function DiscoverSheet({ open, onClose, onOpen }: Props) {
  return (
    <BottomSheet open={open} title={t("profilePage.discover")} icon={PROFILE_ICONS.discover} onClose={onClose} tall className="discover-bsheet">
      <div className="fanhome discover-body">
        <BrowseBody onOpen={onOpen} />
      </div>
    </BottomSheet>
  );
}
